import React, { Component } from 'react';
import PostInput from '../../Shared/PostInput';
import {connect} from "react-redux"

import  {addPeople} from "../../redux/action/peopleAction";
// ES6
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// CommonJS

class PostPeople extends Component {

    handleValueTextdescription= (e) => {
        this.state.description = e    
    }
    

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    // console.log(this.state.oldBlog)
    e.preventDefault();
    this.props.addPeople(this.state);
    console.log(this.state)
    console.log("Hi")
  }

  render() {
    
    return (
      <div className="content" id ="content">
            <div className="panel-center">
                    <h2>Post people</h2>
              </div>


                <form 
                    id="addTaskForm"
                    className="container"
                    autoComplete="off"
                    onSubmit={this.handleSubmit}
                >
                <div className="panel-center">

                    <input type="text" placeholder="Unique Name" className="inputEnter" id="unique_name" onChange={this.handleChange}/>
                    <input type="text" placeholder="Name here.." className="inputEnter" id="name" onChange={this.handleChange}/>
                    <input type="number" placeholder="Category 1-6" className="inputEnter" id="category" onChange={this.handleChange}/>


                  <p>Description</p>
                  <PostInput handleValueText={this.handleValueTextdescription}/>
                  
                  <hr></hr>

                </div>
                  <div className="panel-left">
                    <button type="submit">new</button>
                  </div>
                </form>
               
             
              </div>

    )
  }

}


const mapDispatch = dispatch => {

  // const uid = state.firebase.auth.uid;

  return {
    addPeople: people => dispatch(addPeople(people))
  }
}

export default connect(null, mapDispatch) (PostPeople);
